import './App.css';
import '@fontsource/raleway';
import {BrowserRouter, Route, Routes, useLocation} from "react-router";
import Home from "./screens/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./screens/About";
import {useEffect} from "react";
import Dermal from "./screens/Dermal";
import Skin from "./screens/Skin";
import Mesotherapy from "./screens/Mesotherapy";

function App() {

  return (
    <div>
      <BrowserRouter>
          <ScrollToTop />
          <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products/dermal-filler" element={<Dermal />} />
          <Route path="/products/skin-booster" element={<Skin />} />
          <Route path="/products/mesotherapy" element={<Mesotherapy />} />

        </Routes>
          <Footer />
      </BrowserRouter>
    </div>
  );
}


const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default App;
